import gql from 'graphql-tag'

export const GET_FORMATTED_CITATIONSV2 = gql`
  query GetFormattedCitationsV2(
    $citationProjectId: ID!
    $citationStyle: String!
    $order: CitationsSortOrder = DESC
    $limit: Int = 500
    $page: Int = 1
  ) {
    citations(
      request: {
        citationProjectId: $citationProjectId
        order: $order
        limit: $limit
        page: $page
      }
    ) {
      result {
        data
        id
        createdAt
        annotation
        formattedCitationDataV2(citationStyle: $citationStyle) {
          citation
        }
        contributors {
          firstName
          middleName
          lastName
          function
          data
        }
      }
    }
  }
`

export const GET_FORMATTED_FOOTNOTEV2 = gql`
  query GetFormattedFootnoteV2(
    $citationId: ID!
    $citationProjectId: ID!
    $citationStyle: String!
  ) {
    citation(citationId: $citationId, citationProjectId: $citationProjectId) {
      formattedCitationFootnoteV2(citationStyle: $citationStyle)
    }
  }
`

export const GET_STYLES_V2 = gql`
  query GetCitationStylesV2($keyword: String, $page: Int) {
    citationStylesV2(keyword: $keyword, page: $page) {
      results {
        name
        url
        id
        alias
      }
    }
  }
`
